/**
 * The protection truth, polled [mv2-D2]: the same `/monitoring/deployments`
 * rows (include_closed=false, the key the top bar already polls, so no new
 * requests), aged at `staleAfterMs(POLL.liveMoney)` = 14 s.
 */
import { POLL, useMonitoringDeployments } from '@/api/hooks';
import { staleAfterMs } from '@/lib/liveQueryState';
import { useFreshness } from '@/lib/useFreshness';

import { protectionTruth, type ProtectionTruth } from './protectionTruth';

export function useProtectionTruth(): ProtectionTruth & { refetch: () => void } {
  const query = useMonitoringDeployments();
  const maxAgeMs = staleAfterMs(POLL.liveMoney);
  const clock = useFreshness([{ dataUpdatedAt: query.dataUpdatedAt, maxAgeMs }]);
  return {
    ...protectionTruth(query, { ...clock, maxAgeMs }),
    refetch: () => {
      void query.refetch();
    },
  };
}
